<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark> mdi-keyboard-backspace </v-icon>
        </v-btn>
        <br /><br />
        <div
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
        >
          {{ title }}
        </div>

        <div>
          <br />
          <h2>Mis trámites</h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Documento</th>
                  <th class="text-left">Estado</th>
                  <th class="text-left">Fecha de Entrega</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(tramiteUserData, tramitesUserKey) in tramitesUser"
                  :key="tramitesUserKey"
                >
                  <td>{{ tramiteUserData.documento_entregar.name }}</td>
                  <td>
                    
                      <v-chip
                        class="ma-0"
                        label
                        color="#2D3436"
                        text-color="white"
                        v-if="tramiteUserData.status"
                      >
                        Entregado
                      </v-chip>

                      <v-chip
                        class="ma-0"
                        label
                        color="red"
                        text-color="white"
                        v-else
                      >
                        Pendiente a Retirar
                      </v-chip>
                     
                    
                  </td>
                  <td>
                    {{ tramiteUserData.fecha_entregado }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>  
  <script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "DocumentosSolicitados",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title: "Documentos A Entregar",
    tramitesUser: [],
  }),

  methods: {
    async loadTramites() {
      let url = "documentos_entregar/alumno/" + this.$store.getters.user.IDStB;
      await this.$API
        .get({
          url: url,
        })
        .then((res) => {
          this.tramitesUser = res;
        });
    },
  },

  mounted() {
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({
        name: "Home",
      });
    }

    this.loadTramites();
  },
};
</script>
  